import type { PortableTextComponents } from "next-sanity";

export type InlineRichTextVariant = "accessible" | "address";

const SITE_ORIGIN = "https://www.agencyq.com";
const NEW_TAB_PROPS = { target: "_blank", rel: "noopener noreferrer" } as const;

const isExternalHref = (href: string): boolean => href.startsWith("http") || href.startsWith("//");

/** Hostname for an external link, the path for an internal one, the raw href if it cannot be parsed. */
const linkLabel = (href: string): string => {
  if (!isExternalHref(href)) return href;
  try {
    return new URL(href, SITE_ORIGIN).hostname.replace("www.", "");
  } catch {
    return href;
  }
};

const ACCESSIBLE: PortableTextComponents = {
  marks: {
    link: ({ children, value }) => {
      const href = value?.href || "";
      return (
        <a
          href={href}
          aria-label={linkLabel(href)}
          {...(isExternalHref(href) ? NEW_TAB_PROPS : {})}
          className="hover:text-primary transition-colors duration-300"
        >
          {children}
        </a>
      );
    },
  },
};

const ADDRESS: PortableTextComponents = {
  marks: {
    link: ({ children, value }) => <a href={value?.href}>{children}</a>,
  },
};

const VARIANTS: ReadonlyMap<InlineRichTextVariant, PortableTextComponents> = new Map([
  ["accessible", ACCESSIBLE],
  ["address", ADDRESS],
]);

export function getInlineRichTextVariant(variant: InlineRichTextVariant): PortableTextComponents {
  return VARIANTS.get(variant) ?? ACCESSIBLE;
}
